// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre{font-family:Vazir,serif!important;white-space:break-spaces;overflow:hidden;text-wrap:wrap}.qr-floating-btn{position:absolute;top:14px;left:14px;z-index:20;background-color:hsla(0,0%,100%,.9)!important}", ""]);
// Exports
module.exports = exports;
